export var createEmptyWorkHours = function () { return ({
    paidHoursPerDay: '',
    workingDaysPerWeek: '',
    workingDaysPerYear: '',
}); };
export var createDefaultStaffSettingsFormState = function () { return ({
    avgWeeklyAttrition: '',
    avgMonthlyAttrition: '',
    graduationRate: '',
    recruitingLeadTimeWeeks: '',
    classSize: '',
    agent: createEmptyWorkHours(),
    support: createEmptyWorkHours(),
    isDirty: false,
}); };
